/**
 *
 * @param arr - Array do qual serão removidos os itens com duplicidade na propriedade especificada
 * @param property - Propriedade a ser verificada a duplicidade
 */
export const removeDuplicatesObject = (arr: any[], property: string) => {
  const unique = arr
    .map(e => e[property])
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter((e: any) => arr[e]).map((e: any) => arr[e]);
  return unique;
};
